import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/animations';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiMapPin, FiExternalLink } = FiIcons;

export default function SpeakingEventCard({ event, index }) {
  return (
    <motion.div
      custom={index}
      variants={fadeUp}
      className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-1 transition-all hover:border-blue-400/30 hover:bg-white/10"
    >
      <div className="relative z-10 flex flex-col h-full p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="inline-flex items-center rounded-full bg-blue-500/10 px-3 py-1 text-[10px] font-medium uppercase tracking-wider text-blue-300 border border-blue-500/20">
            {event.type}
          </div>
          <span className="text-white/30 group-hover:text-blue-400 transition-colors">
            <SafeIcon icon={FiExternalLink} className="h-4 w-4" />
          </span>
        </div>

        <h3 className="text-xl font-semibold text-white group-hover:text-blue-100 transition-colors">
          {event.title}
        </h3>
        
        <p className="mt-2 text-sm text-white/60 line-clamp-2">
          {event.organization}
        </p>

        <div className="mt-auto pt-6 flex flex-wrap gap-4 items-center text-xs text-white/50">
          <div className="flex items-center gap-1.5">
            <SafeIcon icon={FiCalendar} className="h-3.5 w-3.5 text-orange-400/70" />
            {event.date}
          </div>
          <div className="flex items-center gap-1.5">
            <SafeIcon icon={FiMapPin} className="h-3.5 w-3.5 text-purple-400/70" />
            {event.location}
          </div>
        </div>
      </div>

      {/* Subtle hover gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-orange-500/5 opacity-0 group-hover:opacity-100 transition-opacity" />
    </motion.div>
  );
}